

import _util from '../../utils/';

const AnnouncementService = {
    fetchAnnouncement (params, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Get?anno_type=2',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchSystemAction (params, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Get?anno_type=1',
            params: params,
            success: resolve,
            error: reject
        })
    },
    selectAnnouncement (params, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    deleteAnnouncement (data, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Delete',
            method: "delete",
            data: data,
            success: resolve,
            error: reject
        })
    },
    updateAnnouncement (data, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Put',
            method: "put",
            data: data,
            success: resolve,
            error: reject
        })
    },
    createAnnouncement (data, resolve, reject) {
        _util.request({
            url: '/api/HROtherAnnouncement/Post',
            method: "post",
            data: data,
            success: resolve,
            error: reject
        })
    },
}


export default AnnouncementService;


// WEBPACK FOOTER //
// ./src/services/Employee/announcement-service.js